import React, { Component, Fragment } from "react";
import { ICDBPageProps } from "../../../../utils/ICDBPageProps";
import { PrimaryButton } from "office-ui-fabric-react";

interface AdminRolloverFormImportPageProps extends ICDBPageProps {
}

interface AdminRolloverFormImportPageState {
    csvFile?: File;
    response?: any[];
}

export default class AdminRolloverFormImportPage extends Component<AdminRolloverFormImportPageProps, AdminRolloverFormImportPageState> {

    constructor(props: AdminRolloverFormImportPageProps) {
        super(props);
        this.state = {};
    }

    async import() {
        try {
            var response = await this.props.apiService.adminImportRolloverForms(this.state.csvFile!);
            this.setState({ response })
            this.props.messageBar.success("Import Complete");
        }
        catch (ex) {
            this.props.messageBar.error(ex.message);
        }
    }

    render() {
        const response = this.state.response?.map((row, i) => <div key={i}>{row}</div>);

        return (
            <Fragment>
                <input 
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                        if (e.target.files?.length === 1) {
                            const file = e.target.files[0];
                            this.setState({
                                csvFile: file
                            })
                        }
                    }}
                />
                <PrimaryButton
                    text="Import"
                    onClick={() => this.import()} />
                <div>
                    {response}
                </div>
            </Fragment>
        );
    }
}
